import React from "react";
import JetpackMLConfig from "./JetpackMLConfig";
import KC_Heading2 from "../../../../designsystem/typography/KC-Heading/KC_Heading2";
import KC_Heading3 from "../../../../designsystem/typography/KC-Heading/KC_Heading3";
import { tt } from "../../../../utils/i18n/i18n";

export default function MLContainer() {
  const mlOptions = [
    {
      name: tt("ml_monthly_prizes"),
      value: "glm",
      desc: tt("ml_monthly_prizes_desc")
    }
  ];

  return (
    <div className="container-fluid p-4">
      <div className="d-flex flex-column st-gap">
        <KC_Heading2 text={tt("ml_configure_title")} />
        <KC_Heading3 text={tt("ml_prize_type_subtitle")} />
        {/*<div className="w-100">*/}
        {/*  <KC_Tabs_Cards*/}
        {/*    items={mlOptions}*/}
        {/*    onSelect={setActiveTab}*/}
        {/*    initialSelectedIndex={0}*/}
        {/*  />*/}
        {/*</div>*/}
      </div>

      <div>
        <JetpackMLConfig />
      </div>
    </div>
  );
}
